import { Paper, Typography } from '@mui/material';
import parse from 'html-react-parser';

type Props = {
  note: string;
};

export default function LegalNote({ note }: Props) {
  return (
    <Paper
      id="legal-note"
      elevation={3}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 99,
        margin: 0.5,
        padding: 1,
      }}
    >
      <Typography
        variant="body2"
        color="textSecondary"
        align="center"
        sx={{
          color: 'white',
        }}
      >
        {parse(note)}
      </Typography>
    </Paper>
  );
}
